var map = {
	"./ion-action-sheet-ios.entry.js": [
		966,
		31
	],
	"./ion-action-sheet-md.entry.js": [
		967,
		32
	],
	"./ion-alert-ios.entry.js": [
		968,
		33
	],
	"./ion-alert-md.entry.js": [
		969,
		34
	],
	"./ion-app_8-ios.entry.js": [
		970,
		13
	],
	"./ion-app_8-md.entry.js": [
		971,
		14
	],
	"./ion-avatar_3-ios.entry.js": [
		972,
		35
	],
	"./ion-avatar_3-md.entry.js": [
		973,
		36
	],
	"./ion-back-button-ios.entry.js": [
		974,
		37
	],
	"./ion-back-button-md.entry.js": [
		975,
		38
	],
	"./ion-backdrop-ios.entry.js": [
		976,
		82
	],
	"./ion-backdrop-md.entry.js": [
		977,
		83
	],
	"./ion-button_2-ios.entry.js": [
		978,
		39
	],
	"./ion-button_2-md.entry.js": [
		979,
		40
	],
	"./ion-card_5-ios.entry.js": [
		980,
		41
	],
	"./ion-card_5-md.entry.js": [
		981,
		42
	],
	"./ion-checkbox-ios.entry.js": [
		982,
		43
	],
	"./ion-checkbox-md.entry.js": [
		983,
		44
	],
	"./ion-chip-ios.entry.js": [
		984,
		45
	],
	"./ion-chip-md.entry.js": [
		985,
		46
	],
	"./ion-col_3.entry.js": [
		986,
		84
	],
	"./ion-datetime_3-ios.entry.js": [
		987,
		19
	],
	"./ion-datetime_3-md.entry.js": [
		988,
		20
	],
	"./ion-fab_3-ios.entry.js": [
		989,
		47
	],
	"./ion-fab_3-md.entry.js": [
		990,
		48
	],
	"./ion-img.entry.js": [
		991,
		85
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		992,
		86
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		993,
		87
	],
	"./ion-input-ios.entry.js": [
		994,
		49
	],
	"./ion-input-md.entry.js": [
		995,
		50
	],
	"./ion-item-option_3-ios.entry.js": [
		996,
		51
	],
	"./ion-item-option_3-md.entry.js": [
		997,
		52
	],
	"./ion-item_8-ios.entry.js": [
		998,
		53
	],
	"./ion-item_8-md.entry.js": [
		999,
		54
	],
	"./ion-loading-ios.entry.js": [
		1000,
		55
	],
	"./ion-loading-md.entry.js": [
		1001,
		56
	],
	"./ion-menu_3-ios.entry.js": [
		1002,
		57
	],
	"./ion-menu_3-md.entry.js": [
		1003,
		58
	],
	"./ion-modal-ios.entry.js": [
		1004,
		15
	],
	"./ion-modal-md.entry.js": [
		1005,
		16
	],
	"./ion-nav_2.entry.js": [
		1006,
		27
	],
	"./ion-popover-ios.entry.js": [
		1007,
		17
	],
	"./ion-popover-md.entry.js": [
		1008,
		18
	],
	"./ion-progress-bar-ios.entry.js": [
		1009,
		59
	],
	"./ion-progress-bar-md.entry.js": [
		1010,
		60
	],
	"./ion-radio_2-ios.entry.js": [
		1011,
		61
	],
	"./ion-radio_2-md.entry.js": [
		1012,
		62
	],
	"./ion-range-ios.entry.js": [
		1013,
		63
	],
	"./ion-range-md.entry.js": [
		1014,
		64
	],
	"./ion-refresher_2-ios.entry.js": [
		1015,
		21
	],
	"./ion-refresher_2-md.entry.js": [
		1016,
		22
	],
	"./ion-reorder_2-ios.entry.js": [
		1017,
		29
	],
	"./ion-reorder_2-md.entry.js": [
		1018,
		30
	],
	"./ion-ripple-effect.entry.js": [
		1019,
		88
	],
	"./ion-route_4.entry.js": [
		1020,
		65
	],
	"./ion-searchbar-ios.entry.js": [
		1021,
		66
	],
	"./ion-searchbar-md.entry.js": [
		1022,
		67
	],
	"./ion-segment_2-ios.entry.js": [
		1023,
		68
	],
	"./ion-segment_2-md.entry.js": [
		1024,
		69
	],
	"./ion-select_3-ios.entry.js": [
		1025,
		70
	],
	"./ion-select_3-md.entry.js": [
		1026,
		71
	],
	"./ion-slide_2-ios.entry.js": [
		1027,
		89
	],
	"./ion-slide_2-md.entry.js": [
		1028,
		90
	],
	"./ion-spinner.entry.js": [
		1029,
		25
	],
	"./ion-split-pane-ios.entry.js": [
		1030,
		91
	],
	"./ion-split-pane-md.entry.js": [
		1031,
		92
	],
	"./ion-tab-bar_2-ios.entry.js": [
		1032,
		72
	],
	"./ion-tab-bar_2-md.entry.js": [
		1033,
		73
	],
	"./ion-tab_2.entry.js": [
		1034,
		28
	],
	"./ion-text.entry.js": [
		1035,
		74
	],
	"./ion-textarea-ios.entry.js": [
		1036,
		75
	],
	"./ion-textarea-md.entry.js": [
		1037,
		76
	],
	"./ion-toast-ios.entry.js": [
		1038,
		77
	],
	"./ion-toast-md.entry.js": [
		1039,
		78
	],
	"./ion-toggle-ios.entry.js": [
		1040,
		23
	],
	"./ion-toggle-md.entry.js": [
		1041,
		24
	],
	"./ion-virtual-scroll.entry.js": [
		1042,
		93
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 811;
module.exports = webpackAsyncContext;